// extracted by mini-css-extract-plugin
export default {"heading":"Contact_heading__VV0-4","links":"Contact_links__w7CEB"};